var getArtStoreApi = function (onCartItemsChange, cartApi, openCart, updateItemValidation, navigateToHomePage, openPopup) {
    return {
        initCartForm: function () { },
        subscribeShowCart: function () { },
        refreshCartItems: function () { },
        openPopup: openPopup,
        showCart: function () { return openCart(); },
        clearCart: function () {
            cartApi.clearAll();
            onCartItemsChange();
        },
        addToCart: function (data) {
            cartApi.addToCart(data);
            updateItemValidation(data);
            onCartItemsChange();
            openCart();
        },
        backHome: function () { return navigateToHomePage(); },
        updateCartItem: function (data) {
            cartApi.updateCartItem(data);
            onCartItemsChange();
            openCart();
        },
        removeFromCart: function (data) {
            cartApi.removeCartItem(data);
            onCartItemsChange();
            openCart();
        },
    };
};
export default getArtStoreApi;
//# sourceMappingURL=artStoreApi.js.map